import React from "react";
import styles from './Job.module.css';

const Job = ({ company, period, title, description, link }) => {
    return (
        <article className={styles.container}>
            <span className={styles.titleCompany}>
                {title} &nbsp;
                <a 
                    href={link} 
                    className={styles.link}
                    target="_blank"
                    rel="noreferrer"
                >
                    @ {company}
                </a>
            </span>
            <span className={styles.period}>{period}</span>
            {
                description.map(desc => (
                    <p key={desc} className={styles.description}>• &nbsp; {desc}</p>
                ))
            }
        </article>
    )
}

export default Job;